module.exports = __webpack_public_path__ + "img/bet_amount_icon.26cb1e2e.svg";